'use strict';

var _ = require('lodash');
var FaresOptimizerAnalysisToolbarController = function FaresOptimizerAnalysisToolbarController($scope, $window, $rootScope, searchCriteriaConstantsService, exportToCSVService, recommendationFilterService, recommendationTransformationService, latestAtpcoTransmissionTimeService, FaresOptimizerConstants, $cacheFactory) {
  var MODES = {
    STRUCTURAL: 'STRUCTURAL',
    TACTICAL: 'TACTICAL'
  };
  var DETAIL_MODES = {
    HOST_VIEW: 'hostView',
    COMPETITIVE_VIEW: 'competitiveView',
    BENCHMARK_VIEW: 'benchmarkView',
    INPUT_DATA: 'inputData'
  };
  $scope.screen = searchCriteriaConstantsService.FARES_OPTIMIZER_ANALYSIS;
  $scope.searchModes = [{
    label: 'Retrieve Last Snapshot',
    mode: searchCriteriaConstantsService.FO_SEARCH_MODES.RETRIEVE_LAST_SNAPSHOT
  }];
  $scope.modes = [{
    label: 'Structural',
    value: MODES.STRUCTURAL
  }, {
    label: 'Tactical',
    value: MODES.TACTICAL
  }];
  $scope.detailModes = [{
    label: 'Host View',
    value: DETAIL_MODES.HOST_VIEW
  }, {
    label: 'Competitive View',
    value: DETAIL_MODES.COMPETITIVE_VIEW
  }, {
    label: 'Benchmark View',
    value: DETAIL_MODES.BENCHMARK_VIEW
  }];
  $scope.initializeState = function () {
    $scope.screenState.recommendMode = $scope.modes[0].value;
    $scope.screenState.recommendationDetailsMode = $scope.detailModes[0].value;
  };
  $scope.initializeState();
  $scope.isProceedNavigation = function () {
    if (_.isEmpty($window.sessionStorage[FaresOptimizerConstants.SESSION_STORAGE_KEYS.RECALCULATED])) {
      return true;
    }
    $scope.$emit('foAnalysisToolbar:recalculatedFarePresent', {
      modalContent: 'isShowMovingAwayContent'
    });
    return false;
  };
  $scope.triggerSearch = function () {
    var $recommendationLadderCache = $cacheFactory.get(FaresOptimizerConstants.RECOMMENDATION_CACHE_KEY);
    if ($recommendationLadderCache) {
      $recommendationLadderCache.removeAll();
    }
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
    latestAtpcoTransmissionTimeService.getLatestAtpcoTranmissionTime().then(function (atpcoTimeStampString) {
      $scope.atpcoTimeStamp = atpcoTimeStampString;
    });
  };
  $scope.exportSummaryToCSV = function () {
    var category = $scope.screenState.recommendMode;
    var filters = $scope.screenState.filters;
    var filteredData = recommendationFilterService.filterRawData($scope.screenState.rawData, filters, category);
    var exportRawData = _.flatten(recommendationTransformationService.getRawDataByMarket(filteredData, $scope.screenState.orderOptions));
    $scope.screenState.recommendationList = recommendationTransformationService.transformRawData(exportRawData, $scope.screenState.orderOptions);
    exportToCSVService.exportToSummaryCSVFormat($scope.screenState.recommendationList);
  };
  $scope.exportToCSV = function () {
    var category = $scope.screenState.recommendMode;
    var filters = $scope.screenState.filters;
    var filteredData = recommendationFilterService.filterRawData($scope.screenState.rawData, filters, category);
    var exportRawData = _.flatten(recommendationTransformationService.getRawDataByMarket(filteredData, $scope.screenState.orderOptions));
    $scope.screenState.recommendationList = recommendationTransformationService.transformRawData(exportRawData, $scope.screenState.orderOptions);
    exportToCSVService.exportToCSVFormat($scope.screenState.recommendationList, 'all', $scope.screenState.recommendMode);
  };
  $scope.$watch('screenState.recommendMode', _.throttle(function () {
    $rootScope.$broadcast('fo:change:recommendationMode');
  }, 200));
};
FaresOptimizerAnalysisToolbarController.$inject = ['$scope', '$window', '$rootScope', 'SearchCriteriaConstantsService', 'FaresOptimizerCSVExportService', 'RecommendationFilterService', 'RecommendationTransformationService', 'LatestAtpcoTransmissionTimeService', 'FaresOptimizerConstants', '$cacheFactory'];
module.exports = FaresOptimizerAnalysisToolbarController;